import { Injectable, Signal } from '@angular/core';

import { User } from '@core/models/entities/user.models';
import { Instructor } from '@core/models/entities/instructor.models';
import { selectUser, selectUserView } from './profile.selectors';
import { ProfileActions } from './profile.actions';

import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UserProfileFacade {
  user$: Observable<{ user: User | null }>;
  user: Signal<{ user: User | null }>;
  userView$: Observable<User | null>;
  userView: Signal<User | null>;

  constructor(private store: Store) {
    this.user$ = this.store.select(selectUser);
    this.user = this.store.selectSignal(selectUser);
    this.userView = this.store.selectSignal(selectUserView);
    this.userView$ = this.store.select(selectUserView);
  }

  initializeProfile(): void {
    this.store.dispatch(ProfileActions.initializeProfile());
  }

  updateProfile(updatedUser: User | Instructor): void {
    this.store.dispatch(ProfileActions.saveUser({ user: updatedUser }));
  }

  acceptWaiver() {
    const updatedUser = { ...this.userView(), waiver_accepted: true } as User;
    this.updateProfile(updatedUser);
  }
}
